import { render } from "./AlterarSenhaEdit.vue?vue&type=template&id=61cb4d47"
import script from "./AlterarSenhaEdit.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__